import React from 'react';
import ReactMarkdown, { Components } from 'react-markdown';

import { ELEMENT_ACTION } from '../../shared/constants';
import { DOMAINS } from '../../shared/constants/Miscellaneous.constants';

import ListItem from '../../components/atoms/list-item/ListItem';

import DeqAnchorLink from '../deq/DeqAnchorLink';

interface ReactMarkdownProps {
  children: string;
  className?: string;
  linkTarget?: string;
  componentType?: string;
  components?: Components;
}

const isDoorpakkenDomain = (url?: string) => {
  if (!url) return false;

  return ['/', DOMAINS.production, DOMAINS.staging, DOMAINS.open].some(
    (internalUrl) => url.startsWith(internalUrl)
  );
};

const MarkdownAnchorLink = ({
  children,
  deqComponentType = 'react-markdown',
  deqActionType,
  ...props
}: {
  children: React.ReactNode;
  deqComponentType?: string;
  deqActionType?: string;
  [key: string]: any;
}) => (
  <DeqAnchorLink
    target={isDoorpakkenDomain(props?.href) ? '_self' : '_blank'}
    deqComponentType={deqComponentType}
    deqActionType={
      !isDoorpakkenDomain(props?.href) ? ELEMENT_ACTION.exit : undefined
    }
    {...props}
  >
    {children}
  </DeqAnchorLink>
);

const ReactMarkdownExtended = ({
  children,
  className,
  linkTarget,
  componentType,
  components,
  ...markdownProps
}: ReactMarkdownProps) => (
  <ReactMarkdown
    data-testid="markdown"
    components={{
      // eslint-disable-next-line react/no-unstable-nested-components
      a: ({ node, ...props }) => (
        <MarkdownAnchorLink
          deqComponentType={componentType}
          {...props}
          {...markdownProps}
        >
          {props.children}
        </MarkdownAnchorLink>
      ),
      li: ListItem,
      ...components,
    }}
    className={className}
  >
    {children}
  </ReactMarkdown>
);

export default ReactMarkdownExtended;
